<template>
  <div class="proTypepage clearfix" style="min-width: 1137px;position: relative">
    <!-- 商品列表页面 -->
    <div class="container clearfix"  id="contain" style=""><!-- @scroll="scrollEvent" -->
      <div id="target"></div>
      <!-- search-input start-->
      <div class="top" id="" v-bind:style="{width: width+'px'}" style="min-width: 1137px;">
        <el-form :inline="true" class="demo-form-inline">
          <!-- proType -->
            <!-- onParamChange('SortType', $event)value-key="value" -->
         <!--  <el-form-item label="商品分类：" class="tinp ">
            <el-select v-model="reqParam.storeClass" clearable class="myselect" @change="selectchange">
              <el-option class="proTypeoption" v-for="item in Sortlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>  -->
          <el-form-item label="商品分类：" class="tinp"> 
            <el-select v-model="storeClass" filterable clearable class="myselect" @change="selectchange"  value-key="code"  auto-complete="off">
              <el-option class="proTypeoption" v-for="item in Sortlist" :key="item.code" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称：" class="tinp">
            <el-input v-model="reqParam.productName" placeholder="请输入商品名称" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
          </el-form-item>
          <el-form-item label="商品编码：" class="tinp">
            <el-input v-model="reqParam.productCode" placeholder="请输入商品编码" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
          </el-form-item>
          <el-button type="primary" class="" size="small" icon="el-icon-search" @click="getlist(false)">搜索</el-button>
          <!--        <el-form-item label="排序方式："  class="tinp" style="margin-left: 20px !important"> 
          
           <div v-if="choosebut=='0'">
            <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'编码')">商品编码</el-button>  
             <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'库存')">当前库存</el-button>
            
            <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'销量')">上月销量</el-button>
            </div>
            <div v-if="choosebut=='1'">
            <el-button v-if="!bianma" type="warning" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'编码')">商品编码</el-button>
            <el-button v-if="bianma" type="warning" class="" size="small" icon="el-icon-sort-down" @click="getlist(false,'编码')">商品编码</el-button>  
             <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'库存')">当前库存</el-button>
            
            <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'销量')">上月销量</el-button>
            </div>
            <div v-if="choosebut=='2'">
            <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'编码')">商品编码</el-button> 
             <el-button v-if="!kucun" type="warning" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'库存')">当前库存</el-button>
            <el-button v-if="kucun" type="warning" class="" size="small" icon="el-icon-sort-down" @click="getlist(false,'库存')">当前库存</el-button>
             <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'销量')">上月销量</el-button>
            </div>
             <div v-if="choosebut=='3'">
              <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'编码')">商品编码</el-button>
              <el-button type="primary" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'库存')">当前库存</el-button>
              <el-button v-if="!xiaoliang" type="warning" class="" size="small" icon="el-icon-sort-up" @click="getlist(false,'销量')">上月销量</el-button>
              <el-button v-if="xiaoliang" type="warning" class="" size="small" icon="el-icon-sort-down" @click="getlist(false,'销量')">上月销量</el-button>
            </div> 
        </el-form-item> -->
          <!-- <el-button type="warning" style="margin-right: 20px" class="fr" size="small" icon="el-icon-refresh" @click="shuaxin">刷新</el-button> -->
        </el-form>
      </div>
      <!-- search-input end-->
      <!-- search-result-list   v-bind:style="{width: width+'px'}"  start-->
      <div class="productbox clearfix" id="prolist" style=" min-width: 1137px;">
        <div class="msgNone" v-if="goodsList.length <= 0" style="text-align: center;font-size: 15px;color: #333">
           <!-- <img src="../../../static/img/loading-svg/loading-spin.svg" v-if="reqPa.loading" width="30" height="30"> -->
        </div>
        <div class="product-list clearfix" style=" min-width: 1137px;" v-bind:class="marright" id="prolistdiv" v-else>
          <ul class="clearfix">
            <li v-for="(item,index) in goodsList"  style="position: relative;height:312px !important"  v-if="false">
               <div class="pro">
                <img src="http://www.it365.net/imgit/P4ea7580b64a61.gif" alt="">
                <!-- <img v-lazy="'../../../static/img/'+item.prodcutImg" alt=""> -->
              </div>
              <div class="promain" style="margin:5px 10px 0px !important">
                <div class="protitle" style="text-align:center;">
                  <b>{{item.materialname}}</b>
                  <div class="promsg clearfix" style="font-size:14px;"><span>{{item.materialcode}}</span></br><span v-if="item.suppliername!=null">{{item.suppliername}}</span></div>
                  <div class="msg">单位:{{item.measdocname}}&nbsp;&nbsp;—&nbsp;&nbsp;箱入数:{{item.boxnum}}</div>
                  <div class="msg">零号仓数量:{{item.localnum}}</div>
                  <div class="promsg">上月销量:{{item.recentnum}}</div>
                </div>
                <div  style="width:156px;position:absolute;top: 278px;">
                  <div class="promsgbot clearfix;"> 
                      <!--  v-show="productInfoFalg" -->
                      <!-- <span class="price" fl>{{item.nprice | currency('￥')}}</span> -->
                      <span class="iconfont icon-gouwuche fr" style="color:#56B8AA;cursor:pointer;" @click="addCart(index)"></span>
                  </div>
                </div>
                <!-- margin-top: 5px; -->
                <!-- <div class="logo" style="text-align:center;position:absolute;top: 182px;">
                  <img src="../../../static/img/log.png" width="44%">
                  </div> -->
                </div>
            </li>
            <li v-for="(item,index) in goodsList"  style="position: relative" v-if="true">
               <!-- <div class="pro"> 
                <img v-lazy="'../../../static/img/'+item.prodcutImg" alt="">
              </div> -->
              <div class="promain">
                <div class="protitle" style="text-align:center;margin: 10px;">
                  <!-- height:36px; -->
                  <div style="height:36px;">
                      <b>{{item.materialname}}</b>
                  </div>
                  <!-- margin-top: 10px -->
                  <div class="promsg clearfix" style="font-size:14px;"><span>{{item.materialcode}}</span></br><span v-if="item.suppliername!=null">{{item.suppliername}}</span></div>
                  <div class="msg">单位:{{item.measdocname}}&nbsp;&nbsp;—&nbsp;&nbsp;箱入数:{{item.boxnum}}</div>
                  <div class="msg">零号仓数量:{{item.localnum}}</div>
                  <div class="promsg">上月销量:{{item.recentnum}}</div>
                </div>
                <div class="promsgbot clearfix" style="width:156px;position:absolute;top: 160px;">
                  <!-- v-show="productInfoFalg" -->
                  <!-- <span class="price" fl>{{item.nprice | currency('￥')}}</span> -->
                  <span class="iconfont icon-gouwuche fr" style="color:#56B8AA;cursor:pointer;" @click="addCart(index)"></span>
                </div>
                <!-- margin-top: 5px; -->
                <div class="logo" style="text-align:center;position:absolute;top: 182px;">
                  <img src="../../../static/img/log.png" width="44%">
                  </div>
                </div>
            </li>
          </ul>
        </div>
        <!--loadMore-->
        <div style="text-align: center;margin-top: 20px;height:60px" v-if="reqPa.loading||reqPa.ends&& count >= 1"> 
          <img src="../../../static/img/loading-svg/loading-spin.svg" v-if="reqPa.loading" width="30" height="30">
          <!-- <span v-if="!reqPa.loading&&reqPa.ends && count >= 1" width="30" height="30">加载完成</span> -->
        </div>
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto " v-if="fenyeFlag">
            <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="reqParam.pageNum"
              :page-size="reqParam.pageSize"
              layout="total,prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            </span>
        </div>
      </div>
      <!--search-result-list end-->
      <el-button type="info" v-show="reqPa.showTop" icon="el-icon-arrow-up" circle id="to-top-btn" style="position:fixed;right:16px;bottom:20px;" @click="toTop"></el-button>
    </div>
    <!-- CartModel start-->
    <div class="model cartModel" v-show="CartShow">
      <div class="content">
        <div class="title">
          <span class="fl">请输入商品数量</span>
          <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="numbox">
          <div class="num">
             <div class="my-input-number" style="width:167px;height:40px;display:flex;border: 1px solid #56b8aa;border-radius: 4px;margin: 0 auto;">
              <el-button type="primary" icon="el-icon-minus" size="mini" :disabled="prabill.productList[0].nznum==CartList.boxnum" style=" " @click="reduce(CartList.boxnum)"></el-button> 
               <!-- 箱入数不可手输 -->
              <input type="text" v-model="prabill.productList[0].nznum" disabled="disabled" style="outline:none;width:80px;font-size:16px;text-align:center;border: 0px;background-color: #fff;"> 
             <!-- 箱入数可手输 -->
              <!-- <input type="text" v-model="prabill.productList[0].nznum" @change="numchange()" style="outline:none;width:80px;font-size:16px;text-align:center;border: 0px;background-color: #fff;"> -->

              <el-button type="primary" icon="el-icon-plus" style=" "  size="mini" @click="add(CartList.boxnum)"></el-button> 
             </div>
     <!--        <InputNumber :count="prabill.productList[0].nznum" :min="CartList.boxnum" :step="CartList.boxnum" @count-change="fatherChange"></InputNumber>   -->
           <!--  <el-input-number :step="CartList.boxnum" :min="CartList.boxnum" size="medium" v-model="prabill.productList[0].nznum" @change="numchange"></el-input-number> -->
          </div>
          <span style="margin-right: 20px">当前库存：{{CartList.localnum}}</span><span style="margin-right: 20px">上月销量：{{CartList.recentnum}}</span><span style="margin-right: 20px">单位：{{CartList.measdocname}}</span>
          <div class="butt clearfix">
            <el-button style="width:120px;margin-bottom: 20px" type="danger" class="fl" @click="closemodel">取消</el-button>
            <el-button style="width:120px;margin-bottom: 20px" type="primary" class="fr" @click="submit">确认</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- CartModel end-->
     
    <!-- model end -->
    <!-- <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div> -->
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<script>
import { currency } from '../../utils/currency'
import { scrollIt } from '../../utils/scrollIt' 
import axiosPost from 'axios'
// import axios from 'axios'
export default {
  name: '',
  inject: ['reload'],
  data() {
    return {
      fenList:[], 
      fenyeFlag:true,
      productInfoFalg:false,
      flag:false,
      modelFlag:false,
      msgShow:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      fullscreenLoading:false,
      methodName:'', 
      utilpath: '',
      addmethod: false,
      InterfacePath: '',
      choosebut: '0',
      count: 0,
      page:1,
      pagesize:12,
      users: {},
      marright: '',
      width: 0,
      bianma: false,
      kucun: false,
      xiaoliang: false,
      CartShow: false, //购物车弹框的显示状态
      CartList: { //购物车数据
        materialcode: '',
        localnum: 0,
        recentnum: 0,
        nznum: 0,
        measdocname: '',
      },
      index: 0,
      Sortlist: [],
      prabill: {
        storecode: '',
        storename: '',
        creatorcode: '',
        creatorname: '',
        productList: [{
          productCode: '',
          productName: '',
          wlspec: '',
          wltype: '',
          vbatchcode: '',
          suppliercode: '',
          suppliername: '',
          nznum: 0,
          localnum: 0,
          recentnum:0,
          boxnum: 0,
          ntaxmny: '',
          nprice: ''
        }]
      },
      goodsList: [], //商品数据集
      reqParam: {
        storecode: '',
        storeClass: '',
        productClass: [], //排序方式
        productName: '', //商品名
        pageNum: 1, //当前页
        pageSize: 12, //每页显示条数
      }, 
      storeClass: '门店一级分类',
      productClass: [],
      reqPa: {
        loading: false, //懒加载图片状态
        showTop: false, //回到顶部状态
        ends: false, //加载完成
        step: 0 //速度
      }
    }
  },
  filters: { //
    currency: currency
  },
  watch: {
    width: function() {
      this.changeFixed(this.width)
    },

  },
  mounted() {
    this.users = JSON.parse(window.localStorage.getItem("userInfo"));
    this.utilpath = this.axios.defaults.baseURL;
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.getSortList();
    this.init();
    this.width = `${document.documentElement.clientWidth}` - 220
    // 浏览器尺寸变化响应事件 ：
    window.onresize = function temp() {
      this.width = `${document.documentElement.clientWidth}` - 220
    };
    
  },
  destroyed() {
    sessionStorage.removeItem("CartShow");
    sessionStorage.removeItem("CartList");
    sessionStorage.removeItem("prabill");
    sessionStorage.removeItem("proList");
    sessionStorage.removeItem("reqParam");
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pagesize = val;
        // console.log(this.pagesize);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.page = val;
        this.reqParam.pageNum=this.page;
        // console.log(this.page);
        this.fullscreenLoading = true;
        this.toTop();
        this.getlist();
        this.fenyeFlag=true;
      },
     // 增加
      add(num){ 
         this.prabill.productList[0].nznum+=num;
      }, 
      // 减少 
      reduce(num){ 
        // console.log("1打印当前this.prabill.productList[0].nznum数值："+this.prabill.productList[0].nznum)
         if(this.prabill.productList[0].nznum==num){ 
            this.prabill.productList[0].nznum=num; 
         }else{
            this.prabill.productList[0].nznum-=num;
         }
        // console.log("2打印当前this.prabill.productList[0].nznum数值："+this.prabill.productList[0].nznum)
    },
    fatherChange(count){
      // 监听数字的变化 
      this.prabill.productList[0].nznum = count;
    },
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                // console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      //  this.$alert('门店请购单信息删除失败', '失败信息', {
                      //   confirmButtonText: '确定'
                      // });
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow = false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                })
            }
            if(this.methodName == "NUMmessage1" || this.methodName == "NUMmessage2"){
               this.prabill.productList[0].nznum  = this.CartList.boxnum
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },  
    shuaxin() {
      // console.log("-=-=--=-=-=-=-=刷新前");
      this.reload();
      // console.log("-=-=-=-=-=--=--=-=-=--=刷新后");
    },
    changeFixed(clientWidth) { //动态修改样式
      // console.log("查看宽度2：--》" + clientWidth);
      //this.$refs.mainDiv.style.width = clientWidth+'px';
      this.marright = "mar6";
      // if(1146 > clientWidth && clientWidth> 946){
      //   this.marright="mar5";
      //    console.log("-=-=-=-=-=-=-=-= 5"+this.width)
      // }else if(1146-11.8*14>clientWidth && clientWidth>757){
      //   this.marright="mar4";
      //   console.log("-=-=-=-=-=-=-=-= 4"+this.width)
      // }else if(1146-11.8*14*2>clientWidth && clientWidth>568){
      //   this.marright="mar3";
      //   console.log("-=-=-=-=-=-=-=-= 3"+this.width)
      // }else if(570>clientWidth && clientWidth>379){
      //   this.marright="mar2";
      //   console.log("-=-=-=-=-=-=-=-= 2"+this.width)
      // }

    },
    selectchange(value) {
      this.reqParam.pageNum=1;
      // console.log("下拉变化事件1" + JSON.stringify(value) + "下标："); 
      this.storeClass=value.name; 
      this.reqParam.storeClass=value.code; 
      // console.log("下拉变化事件1" + JSON.stringify(this.reqParam.storeClass) + "下标："); 
      this.fullscreenLoading = true;
      this.fenList=[];
      // this.getlist();
    },
    numchange() { 
      var inpnum = this.prabill.productList[0].nznum 
      var boxnum = this.CartList.boxnum
      if(inpnum > boxnum && inpnum % boxnum ==0 ){
        
        this.prabill.productList[0].ntaxmny = this.prabill.productList[0].nznum * this.prabill.productList[0].nprice; 
      }else{
         if(inpnum<boxnum){
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'NUMmessage2';
            this.msg = '输入数量出库不能小于箱入数！';
            this.butflag =false;
            this.butmsg='知道了'; 
            this.productInfoFalg=true; 

         }else{
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'NUMmessage1';
            this.msg = '您输入的数量不是箱入数的倍数，请重输！';
            this.butflag =false;
            this.butmsg='知道了'; 
            this.productInfoFalg=true; 
         }
       
        
      }
    },
    scrollEvent(e) {
      if(this.goodsList.length<60){ 
            // this.scrollToTop();
            this.reqPa.showTop = e.srcElement.scrollTop > 800 ? true : false;
            //滚动的像素+容器的高度>可滚动的总高度-20像素
            // console.log("触发滚动事件");
            if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 20 && this.reqPa.loading) {
              this.getlist(true); //加载更多
            }
      }else{
          this.fenyeFlag=true;
          this.reqPa.loading = false;
          this.reqPa.ends = false;
      }
    },
    toTop() {
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById("contain").scrollTop) / 8
      this.reqPa.step += dis;
      document.getElementById("contain").scrollTop -= dis;
      var scroll = document.getElementById("contain").scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内的scrollTop" + document.getElementById("contain").scrollTop);
        // this.reqPa.step+=dis
        var c = setTimeout(() => this.toTop(), 16);
      } else {
        clearTimeout(c);
      }
    },

    getlist(flag) {
      this.goodsList =[];
      this.reqPa.loading = true;
      var dataFlag = false;
      var dataIndex;
      for(var ii=0;ii<this.fenList.length;ii++){
        if(this.fenList[ii].num == this.reqParam.pageNum){
          dataFlag=true;
          dataIndex = ii;
          break;
        }
      }
       
      if(dataFlag){
         this.goodsList = this.fenList[dataIndex].context;
         this.reqPa.loading =false;
      }else{
      if (flag) {
        this.reqParam.pageNum += 1; 
        this.page=this.reqParam.pageNum;
        // console.log("-=-==-=-=--=-=-页码" + this.reqParam.pageNum);
      }
      // if(msg == '编码'){
      //   this.choosebut = '1';
      //   this.bianma=!this.bianma;
      //   this.reqParam.orderType='0';
      //   if(this.bianma){
      //     this.reqParam.orderType='1';
      //   }
      // }else if(msg == '库存'){
      //   this.choosebut = '2';
      //   this.kucun=!this.kucun
      //   this.reqParam.orderType='2';
      //   if(this.bianma){
      //     this.reqParam.orderType='3';
      //   }
      // }else if(msg == '销量'){
      //   this.choosebut = '3';
      //   this.xiaoliang=!this.xiaoliang
      //   this.reqParam.orderType='4';
      //   if(this.bianma){
      //     this.reqParam.orderType='5';
      //   }
      // };
      this.reqParam.storecode = this.users.storecode
      this.reqParam.productClass = this.productClass;
      var reqParams = {
        parameter: JSON.stringify(this.reqParam),
      };
      
      //接口请求      
      sessionStorage.setItem("reqParam", JSON.stringify(this.reqParam));
      // console.log("打印参数getSpdirectory："+JSON.stringify(this.reqParam));
      this.$http.post(this.utilpath + '/getSpdirectory', reqParams, { emulateJSON: true,_timeout:600 }).then((result) => {
        // this.$http.post("/ktnapi/getSpdirectory",reqParams,{emulateJSON:true}).then((result) => {
        // this.$post('/getSpdirectory",reqParams,{emulateJSON:true}).then((result) => {
        // this.$http.post(this.InterfacePath+"/getSpdirectory",reqParams,{emulateJSON:true}).then((result) => {  
        var res = result.data;
        if (res.status == '0') {
              this.fullscreenLoading = false;
              if (flag) { 
                      if (this.reqParam.pageSize > res.resultList.length) {
                        this.reqPa.loading = true;
                        this.reqPa.ends = false;
                      } else {
                        this.reqPa.ends = true;
                      } 
                      this.goodsList = this.goodsList.concat(res.resultList);

              } else {  
                    
                    if (this.reqParam.pageSize > res.resultList.length) {
                      this.reqPa.ends = false;
                    } else {
                      this.reqPa.ends = true;
                    } 
                     
                    this.goodsList = res.resultList;
                    this.reqPa.loading = false;
                    var fencontent={num:this.reqParam.pageNum,context:this.goodsList};
                    this.fenList.push(fencontent);
                    // console.log("当前页对象："+JSON.stringify(this.fenList));
              }
              sessionStorage.setItem("proList", JSON.stringify(this.goodsList)); 
              this.count = res.countNum; 
              if (this.count == this.goodsList.length) {
                // console.log("关闭等待状态");
                this.reqPa.loading = false;
                this.reqPa.ends = true;
              }
              if(res.productInfoFalg=='1'){
                  this.fullscreenLoading = false;
                  this.modelFlag = true;
                  this.msgShow = true;
                  this.methodName = 'message';
                  this.msg = '商品：\n'+res.message+'重复了，请让总部排查';
                  this.butflag =false;
                  this.butmsg='知道了'; 
                  this.productInfoFalg=true; 
              }else{
                this.productInfoFalg=false;
              }
              // console.log("打印productInfoFalg："+this.productInfoFalg);
        } else if (res.status == '-1') {
          this.fullscreenLoading = false;
          this.reqPa.loading = false;
          // console.log("-----暂无数据！！！");
        } else if(res.status == '9'){
          this.fullscreenLoading =false;
          this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.message;
          this.butflag =false;
          this.butmsg='知道了'; 
          this.reqPa.loading = false;  
        }    
      }, (err) => {
        this.fullscreenLoading = false;
        this.reqPa.loading = false;
        this.msgShow = false;
        this.modelFlag = true;
        this.methodName = 'message';
        this.msg = '查询商品目录清单接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
      }
    },
    getSortList(){
      this.$http.post(this.utilpath + '/selectStoreClass', { emulateJSON: true,_timeout:600}).then((res) => {
          if (res.data.status == '0') {  
            this.Sortlist = res.data.resultList; 
            this.storeClass =this.Sortlist[0].name;
            this.reqParam.storeClass=this.Sortlist[0].code;
            // this.getlist();
            // console.log("打印商品类型" + JSON.stringify(this.Sortlist));
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
          } else if (res.data.status == '-1') {
            this.Sortlist = [];
            this.$message({
              showClose:true,
              message:'商品类型无数据',
              type:'info'
            });  
          } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
          }
       }, (err) => {
        this.reqPa.loading = false;
        this.msgShow = false;
        this.modelFlag = true;
        this.methodName = 'message';
        this.msg = '调用查询商品类型接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    }, 
    getProDuctType() {
      this.$http.post(this.utilpath + '/selectSpdirectoryClass', { emulateJSON: true,_timeout:600}).then((res) => {
        // this.$http.post("/ktnapi/selectSpdirectoryClass",{emulateJSON:true}).then((res) => {
        //this.$post('/selectSpdirectoryClass",{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+"/selectSpdirectoryClass",{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') { 
          var getProDuctType = res.data.resultList;
          this.Sortlist = [];
          for (var i = getProDuctType.length - 1; i > -1; i--) {
            this.Sortlist.push({ classname: getProDuctType[i].classname, classcode: getProDuctType[i].classcode });
          }
          // console.log("打印商品类型" + JSON.stringify(this.Sortlist));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
          this.$router.push({path:'/ui/login',query:{msg:9}});
        } else if (res.data.status == '-1') {
          this.Sortlist = [];
          this.$message({
            showClose:true,
            message:'商品类型无数据',
            type:'info'
          });  
        } else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }
      }, (err) => {
        this.reqPa.loading = false;
        this.msgShow = false;
        this.modelFlag = true;
        this.methodName = 'message';
        this.msg = '调用查询商品类型接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    init() {
      //获取购物车弹窗的显示状态的session值
      var Show1 = sessionStorage.getItem("CartShow");
      var list = JSON.parse(sessionStorage.getItem("CartList"));
      var list2 = JSON.parse(sessionStorage.getItem("prabill"));
      // var porlist = JSON.parse(sessionStorage.getItem("proList"));
      var reqParam = JSON.parse(sessionStorage.getItem("reqParam"));
      if (Show1 != null) { //判断是否存在，不存在设置默认值
        this.CartShow = Show1;
        this.CartList = list;
        this.prabill = list2;
      }
      if (reqParam != null) {
        this.reqParam = reqParam;
        this.reqParam.pageNum = 1;
        this.reqParam.pageSize = 12;
      } 
      // this.getlist();
      // this.getProDuctType();  
    },
    submit() { //提交购物车
      sessionStorage.removeItem("CartShow");
      sessionStorage.removeItem("CartList");
      sessionStorage.removeItem("prabill");
      this.CartShow = false;
      var reqParams = this.prabill; //请求参数
      // console.log(JSON.stringify(this.prabill));
      var pram = {
        prabill: JSON.stringify(this.prabill)
      }; 
      // this.prabill= JSON.stringify(this.prabill);
      // this.$http.get("api/productList",reqParams).then((result) => { 
      
      
      this.fullscreenLoading = true;


       axiosPost.post(
                this.utilpath+ '/insertPrabill' ,
                pram
        ).then((result) =>{          //这里使用了ES6的语法
                  var res = result.data.status; 
                  if (res == '0') { //符合条件弹出成功提示
                    this.fullscreenLoading = false;
                    this.$message({
                      showClose: true,
                      message: '提交成功！',
                      type: 'success'
                    });
                  } else if(res == '9'){
                    this.$router.push({path:'/ui/login',query:{msg:9}});
                  } else {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = result.data.message;
                    this.butflag =false;
                    this.butmsg='知道了'; 
                  }
            }).catch((error) =>{
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow = false;
                this.methodName = 'message';
                this.msg = error;
                this.butflag =false;
                this.butmsg='知道了'; 
        })
      // this.$http.post(this.utilpath + '/insertPrabill', pram, { emulateJSON: true ,_timeout:600}).then((result) => { 
      //   // this.$http.post("/ktnapi/insertPrabill",pram,{emulateJSON:true}).then((result) => {
      //   // this.$post('/insertPrabill",pram,{emulateJSON:true}).then((result) => {
      //   // this.$http.post(this.InterfacePath+"/insertPrabill",pram,{emulateJSON:true}).then((result) => {
      //   // this.$http.post("ktnapi/insertPrabill",pram,{emulateJSON:true}).then((result) => {
      //   var res = result.data.status; 
      //   if (res == '0') { //符合条件弹出成功提示
      //     this.fullscreenLoading = false;
      //     this.$message({
      //       showClose: true,
      //       message: '提交成功！',
      //       type: 'success'
      //     });
      //   } else if(res == '9'){
      //     this.$router.push({path:'/ui/login',query:{msg:9}});
      //   } else {
      //     this.fullscreenLoading = false;
      //     this.modelFlag = true;
      //     this.msgShow = true;
      //     this.methodName = 'message';
      //     this.msg = result.data.message;
      //     this.butflag =false;
      //     this.butmsg='知道了'; 
      //   }
      // }, (err) => {
      //   this.fullscreenLoading = false;
      //   this.modelFlag = true;
      //   this.msgShow = false;
      //   this.methodName = 'message';
      //   this.msg = err;
      //   this.butflag =false;
      //   this.butmsg='知道了'; 
      // });
    },
    onParamChange(attr, val) { //搜索数据变更事件 
      this.fenList=[];
      // this.getlist();
    },
    loadMore() {
      setTimeout(() => { 
        this.getlist(true);
      }, 1000);

    },
    addCart(index) { //添加购物车方法
      this.index = index;
      this.CartList = this.goodsList[index];
      var carNprice = JSON.parse(JSON.stringify(this.CartList));
      // this.prabill.productList=[];
      this.prabill = {
        storecode: this.users.storecode,
        storename: this.users.storename,
        creatorcode: this.users.user_code,
        creatorname: this.users.user_name,
        corpcode:this.users.corpcode,
        corpname:this.users.corpname,
        productList: [{
          productCode: this.goodsList[index].materialcode,
          productName: this.goodsList[index].materialname,
          wlspec: this.goodsList[index].wlspec = this.goodsList[index].wlspec == null ? '' : this.goodsList[index].wlspec,
          wltype: this.goodsList[index].wltype = this.goodsList[index].wltype == null ? '' : this.goodsList[index].wltype,
          vbatchcode: this.goodsList[index].vbatchcode,
          cunitcode: this.goodsList[index].measdoccode,
          cunitname: this.goodsList[index].measdocname,
          taxratecode: this.goodsList[index].taxratecode,
          taxratename: this.goodsList[index].taxratename,
          suppliercode: this.goodsList[index].suppliercode,
          suppliername: this.goodsList[index].suppliername,
          nznum: this.goodsList[index].boxnum,
          vdef3: this.goodsList[index].boxnum,
          vdef4:this.goodsList[index].recentnum,
          vdef5:this.goodsList[index].localnum,
          boxnum: this.goodsList[index].boxnum,
          ntaxmny: carNprice.nprice,
          nprice: this.goodsList[index].nprice
        }]
      }; 
      // console.log("打印提交的数据" + JSON.stringify(this.prabill));
      this.CartShow = true;
      // 将购物车数据存入session，防止页面刷新数据消失
      sessionStorage.setItem("CartShow", true);
      sessionStorage.setItem("CartList", JSON.stringify(this.CartList));
      sessionStorage.setItem("prabill", JSON.stringify(this.prabill));
      // console.log("购物车："+JSON.stringify(this.CartList));
    },
    closemodel() { //关闭购物车弹出框
      sessionStorage.removeItem("CartShow");
      this.CartShow = false;
    }
  }
}

</script>
<style scoped>
.container {
  scrollbar-base-color: transparent;
  scrollbar-darkshadow-color: transparent;
  scrollbar-highlight-color: transparent;
  scrollbar-face-color: transparent;
}

</style>



// WEBPACK FOOTER //
// src/views/order/proVue.vue